import {useState} from 'react'
import GeneCoverageHeathMap from './GeneCoverageHeathMap'

const GeneCoverageSummaryModal = ({
  groupedData,
  isOpen,
  onClose,
  coverageData,
  baseCoverageData,
  fetchCoverageDataByGene,
  fetchCoverageData,
  runId,
  node,
  sampleId,
  maxDepthThreshold,
  setMaxDepthThreshold,
  coverageIsLoading,
  metric,
  setCoverageData,
  sort,
  sortDirection,
  searchTerm,
  minRange,
  maxRange,
  minRangeValue,
  maxRangeValue,
  filterByRegions,
  showListedOnly,
  filteredGenes,
  baseFilteredGenes,
  setFilteredGenes,
  setBaseFilteredGenes,
  setShowListedOnly,
  setFilterByRegions,
  setMaxRange,
  setMinRange,
  setMinRangeValue,
  setMaxRangeValue,
  setMetric,
  setSort,
  setSortDirection,
  setSearchTerm,
  setMaxDepthThresholdPrev,
  maxDepthThresholdPrev,
  filterMetric,
  setFilterMetric,
}) => {
  const [showChart, setShowChart] = useState(false)

  if (!coverageData || !coverageData.genes) {
    return <p>Loading...</p>
  }
  return (
    <div className={`modal fade ${isOpen ? 'show d-block' : 'd-none'}`} tabIndex='-1' role='dialog'>
      {isOpen && <div className='modal-backdrop fade show' onClick={onClose}></div>}

      <div
        className='modal-dialog modal-md'
        role='document'
        style={{maxWidth: '65%', minWidth: '45%', zIndex: 9999}}
      >
        <div className='modal-content' style={{minHeight: '650px'}}>
          <div className='modal-header py-1 px-3 justify-content-end'>
            {/* <h5 className='modal-title d-flex align-items-center gap-4'>
              <span>Gene Sequencing Heatmap</span>
            </h5> */}
            <button
              type='button'
              className='btn btn-white btn-bordered py-1 px-2'
              onClick={onClose}
              aria-label='Close'
            >
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>

          <div className='modal-body py-1' style={{overflow: 'auto'}}>
            <div className='mb-4'>
              {coverageIsLoading || !coverageData  ? (
                <div className='d-flex justify-content-center align-items-center'>
                  <div className='spinner-border text-primary' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                </div>
              ) : (
                <GeneCoverageHeathMap
                  baseCoverageData={baseCoverageData}
                  setMinRange={setMinRange}
                  fetchCoverageData={fetchCoverageData}
                  node={node}
                  sampleId={sampleId}
                  setBaseFilteredGenes={setBaseFilteredGenes}
                  baseFilteredGenes={baseFilteredGenes}
                  setFilteredGenes={setFilteredGenes}
                  setMaxRange={setMaxRange}
                  setMinRangeValue={setMinRangeValue}
                  setMaxRangeValue={setMaxRangeValue}
                  setFilterMetric={setFilterMetric}
                  groupedData={groupedData}
                  setMaxDepthThreshold={setMaxDepthThreshold}
                  maxDepthThreshold={maxDepthThreshold}
                  runId={runId}
                  fetchCoverageDataByGene={fetchCoverageDataByGene}
                  coverageData={coverageData}
                  onClick={() => setShowChart(!showChart)}
                  filteredGenes={filteredGenes}
                  searchTerm={searchTerm}
                  minRange={minRange}
                  maxRange={maxRange}
                  minRangeValue={minRangeValue}
                  maxRangeValue={maxRangeValue}
                  filterByRegions={filterByRegions}
                  showListedOnly={showListedOnly}
                  setCoverageData={setCoverageData}
                  sort={sort}
                  sortDirection={sortDirection}
                  metric={metric}
                  filterMetric={filterMetric}
                  setFilterByRegions={setFilterByRegions}
                  setShowListedOnly={setShowListedOnly}
                  setMaxDepthThresholdPrev={setMaxDepthThresholdPrev}
                  maxDepthThresholdPrev={maxDepthThresholdPrev}
                  setMetric={setMetric}
                  setSort={setSort}
                  setSortDirection={setSortDirection}
                  setSearchTerm={setSearchTerm}
                />
              )}
            </div>

            {/* {showChart && (
              <div className='bg-white p-4 border rounded'>
                <h6 className='mb-3'>Regions Plot for {regionsData.geneName}</h6>
                <div
                  onMouseMove={(e) => {
                    const points = chartRef.current.getElementsAtEventForMode(
                      e.nativeEvent,
                      'nearest',
                      { intersect: true },
                      true
                    )
                    e.target.style.cursor = points.length ? 'pointer' : 'default'
                  }}
                >
                  <GenesChart ref={chartRef} data={regionsData} />
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default GeneCoverageSummaryModal
